export const topics = [
  {
    id: "variety-mingchangmian-2026",
    title: "年度综艺名场面盘点：这届观众为何集体破防",
    categoryId: "variety",
    category: "综艺",
    summary:
      "从慢综艺里的告别，到竞技节目最后一秒的逆风翻盘，名场面之所以成立，往往不是因为剧本，而是因为那一刻的真实。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20collage%20illustration%20of%20a%20vintage%20television%20set%20surrounded%20by%20abstract%20geometric%20shapes%20in%20warm%20coral%20and%20cream%20tones%2C%20stylized%20retro%20broadcast%20aesthetic%2C%20soft%20grain%20texture%2C%20modern%20Chinese%20pop%20culture%20mood%2C%20no%20text%2C%20clean%20composition&width=1200&height=800&seq=gty-cover-01&orientation=landscape",
    heat: 9832,
    comments: 486,
    views: 128450,
    author: "瓜田观察员",
    authorRole: "内容编辑",
    publishedAt: "2026-09-08",
    readTime: 6,
    tags: ["综艺", "名场面", "情绪价值"],
    content: [
      "一整年的综艺看下来，能被反复剪出来做二创的镜头，其实没有几个。我们把这批画面重新看了一遍，发现它们有一个共同点：都不是设计出来的高光，而是嘉宾在失控边缘做出的真实反应。",
      "慢综艺《山海之间》最后一期，四位常驻在厨房里沉默地收拾了整整八分钟，没有背景音乐，没有字幕特效。弹幕从「怎么不剪快一点」逐渐变成「别关掉，我想再看一会儿」。这种留白在过去被认为是剪辑失误，现在却成了最有记忆点的一幕。",
      "竞技节目里，逆风翻盘的桥段每年都有，但真正让人记住的是翻盘失败之后再站起来的那次尝试。观众并不真的在乎谁赢，而是在意有人愿意在明知会输的情况下继续努力。",
      "有意思的是，越是「没有剧本感」的段落，讨论区的分歧越大。有人觉得那是真实，有人坚持认为那是另一种更高级的表演。这种分歧本身，或许就是名场面成立的前提。",
    ],
    timeline: [
      { time: "09-03", text: "盘点话题在讨论区被首次提出，单条评论破千" },
      { time: "09-05", text: "多个二创账号集中发布名场面合集，话题热度上升" },
      { time: "09-07", text: "节目组在采访中回应「无剧本」的说法，引发第二轮讨论" },
      { time: "09-08", text: "话题登上站内话题榜前三，观点交锋进入白热阶段" },
    ],
    relatedIds: ["film-dajieju-lanwei", "variety-jianji-zhengyi", "star-gongzuoshi-huiying"],
  },
  {
    id: "film-dajieju-lanwei",
    title: "剧集大结局引热议：开放式结局到底算不算烂尾",
    categoryId: "film",
    category: "影视",
    summary:
      "留下空白是高级，还是偷懒？同一个结局，两拨观众的结论完全相反，争论从弹幕一路延伸到讨论区。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20film%20reel%20unspooling%20into%20abstract%20shapes%20in%20warm%20coral%20amber%20and%20cream%20tones%2C%20stylized%20cinema%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20modern%20editorial%20layout%2C%20no%20text%2C%20clean%20balanced%20composition&width=1200&height=800&seq=gty-cover-02&orientation=landscape",
    heat: 8764,
    comments: 612,
    views: 156320,
    author: "追剧不出戏",
    authorRole: "特约撰稿",
    publishedAt: "2026-09-07",
    readTime: 7,
    tags: ["影视", "结局", "剧评"],
    content: [
      "一部讨论度极高的都市剧收官，最后一个镜头停在了主角推开门的背影，门后是什么，剧里没有说。这个处理在开播前就已被剧透讨论过，但真正播出来之后，观众的反应依然分裂。",
      "支持的一方认为，开放式结局把解释权还给了观众，人物关系已经完成闭环，剩下的是想象空间。反对的一方则指出，前面铺设的几条支线一条都没收回，这不是留白，是没写完。",
      "我们统计了讨论区里近六百条带观点的评论，发现立场与观剧方式强相关：从第一集就跟着追的人更倾向于接受开放结局，而集中刷完的人更容易感到被辜负。等待本身会放大期待，期待落空时就变成了不满。",
      "编剧在后采里提到，最初的剧本其实拍了另一个明确的结尾，但在剪辑阶段被放弃。这个信息让争论又转向了新一层：创作者到底该忠于自己的表达，还是回应观众的投入。",
    ],
    timeline: [
      { time: "09-01", text: "大结局上线，当晚话题热度冲到全天第一" },
      { time: "09-02", text: "「烂尾」与「高级」两个关键词同时登上站内热搜" },
      { time: "09-04", text: "编剧后采释出，透露曾拍摄其他版本结尾" },
      { time: "09-07", text: "观点交锋帖累计回复超过六百条" },
    ],
    relatedIds: ["variety-mingchangmian-2026", "industry-duanju-nengreng-jiu", "film-guzhuang-zaoxing"],
  },
  {
    id: "concert-yingyuan-neijuan",
    title: "演唱会应援卷出新高度：荧光棒还是应援服",
    categoryId: "concert",
    category: "演出",
    summary:
      "从统一色荧光棒到整条街的应援大巴，应援这件事早就超出了现场，变成了城市级别的情绪表达。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20concert%20stage%20with%20abstract%20light%20beams%20and%20glowing%20shapes%20in%20coral%20red%20amber%20and%20cream%20tones%2C%20stylized%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20modern%20editorial%20style%2C%20no%20text%2C%20dynamic%20balanced%20composition&width=1200&height=800&seq=gty-cover-03&orientation=landscape",
    heat: 7420,
    comments: 358,
    views: 98240,
    author: "现场第一排",
    authorRole: "演出观察",
    publishedAt: "2026-09-06",
    readTime: 5,
    tags: ["演出", "应援", "粉丝文化"],
    content: [
      "过去的应援是一根荧光棒，现在的应援是一整套视觉识别系统。统一色、统一灯牌、统一应援服，甚至统一到入场路线的每个转角要放什么物料，都有详细的执行手册。",
      "这本手册的出现是好事也是压力。好处是现场观感更整齐，新入坑的人也更容易找到归属；压力则在于，当应援变成一项需要「完成」的任务，没跟上的人会产生被排除感。",
      "在讨论区里，有用户提到自己只是想去听歌，结果被现场志愿者提醒荧光棒颜色不对。这条分享获得了大量共鸣，也引出了一个新的问题：我们究竟是在为演出应援，还是在为一种集体仪式应援。",
      "演出产业的朋友给了一个相对中性的判断：应援本质上是粉丝把线上情绪转移到线下的出口，只要不影响到普通观众，它就是中性的。真正需要警惕的，是把参与感量化为消费额度的那部分。",
    ],
    timeline: [
      { time: "09-02", text: "某站巡演现场应援手册流出，引发讨论" },
      { time: "09-04", text: "「只想听歌」的观点帖获得高赞" },
      { time: "09-06", text: "话题进入演出分类热榜，观点分化明显" },
    ],
    relatedIds: ["variety-mingchangmian-2026", "music-yinyuejie-chuanda", "star-gongzuoshi-huiying"],
  },
  {
    id: "industry-duanju-nengreng-jiu",
    title: "短剧爆火之后：三分钟一集的快乐能持续多久",
    categoryId: "industry",
    category: "行业观察",
    summary:
      "反转密度越来越高，单集越来越短，短剧用极致的节奏抓住了注意力，也把观众的耐心阈值推到了新位置。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20smartphone%20screen%20fragmenting%20into%20abstract%20geometric%20shapes%20in%20warm%20coral%20orange%20and%20cream%20tones%2C%20stylized%20tech%20culture%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20no%20text%2C%20clean%20modern%20composition&width=1200&height=800&seq=gty-cover-04&orientation=landscape",
    heat: 6890,
    comments: 274,
    views: 84300,
    author: "内容产业笔记",
    authorRole: "行业观察",
    publishedAt: "2026-09-05",
    readTime: 8,
    tags: ["短剧", "行业", "内容趋势"],
    content: [
      "短剧的节奏是经过精密计算的：开场十秒必须出现冲突，每集结尾必须卡在情绪最高点，下一集的前三秒要立刻给出回应。这套结构之所以有效，是因为它把「要不要继续看」的决定压缩到了一个几乎不需要思考的瞬间。",
      "但结构有效不代表内容可持续。当所有短剧都按同一套公式生产，观众会迅速建立起免疫。今年上半年，同类题材的完播率已经出现明显下滑，反而是节奏稍慢、人物关系更复杂的一批作品跑出了意外成绩。",
      "从讨论区的反馈看，观众并不是排斥短，而是排斥「为了短而短」。当一集的长度刚好装得下一个完整的小情绪，三分钟是舒服的；当它只是为了留住你，三分钟就变成了打扰。",
      "行业里比较一致的判断是：短剧不会消失，但会分化。一部分继续做极致的爽感，另一部分转向更细腻的短剧集，中间地带反而最危险。",
    ],
    timeline: [
      { time: "08-28", text: "多部短剧同期上线，同类题材竞争加剧" },
      { time: "09-03", text: "完播率下滑的数据被行业账号引用讨论" },
      { time: "09-05", text: "「为了短而短」成为讨论区高频观点" },
    ],
    relatedIds: ["film-dajieju-lanwei", "industry-duanju-nengreng-jiu", "variety-jianji-zhengyi"],
  },
  {
    id: "star-gongzuoshi-huiying",
    title: "工作室回应越来越模板化，网友：能不能有点诚意",
    categoryId: "star",
    category: "明星动态",
    summary:
      "同样的措辞、同样的段落结构、同样的落款格式，当回应变成填空题，公众的信任也在一点点被消耗。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20vintage%20microphone%20and%20floating%20speech%20bubbles%20in%20warm%20coral%20red%20amber%20and%20cream%20tones%2C%20stylized%20press%20aesthetic%2C%20soft%20grain%20texture%2C%20modern%20editorial%20style%2C%20no%20text%2C%20balanced%20composition&width=1200&height=800&seq=gty-cover-05&orientation=landscape",
    heat: 9210,
    comments: 533,
    views: 141200,
    author: "围观不站队",
    authorRole: "内容编辑",
    publishedAt: "2026-09-09",
    readTime: 5,
    tags: ["明星动态", "工作室", "公众沟通"],
    content: [
      "细心的网友把这些年出现过的声明放在一起比对，发现「占用公共资源」「保留追究法律责任的权利」「感谢大家的关心」这几句几乎从未缺席，连语气词的位置都高度相似。",
      "声明追求的是准确与合规，这本身没有问题。问题在于，当所有回应都长成同一个样子，它就很难再传递出「我们真的在意」的信号。公众要的未必是道歉，而是被认真对待的感觉。",
      "讨论区里有一条评论被反复引用：模板不是错，只回复模板就是错。信息的模糊会留下解释空间，而被留下的解释空间，最终都会被更激烈的猜测填满。",
      "也有从业者提出不同看法，认为过度回应同样会带来风险，尤其在事实尚未清晰的时候。如何在沉默与表态之间找到合适的刻度，是每个团队都要面对的真实难题。",
    ],
    timeline: [
      { time: "09-06", text: "一份声明发布，措辞与其他事件高度相似" },
      { time: "09-07", text: "网友开始自发整理「声明模板」合集" },
      { time: "09-09", text: "「模板化回应」成为站内当天讨论最热话题之一" },
    ],
    relatedIds: ["variety-mingchangmian-2026", "music-yinyuejie-chuanda", "concert-yingyuan-neijuan"],
  },
  {
    id: "music-yinyuejie-chuanda",
    title: "音乐节穿搭大赏：从野餐风到机能风的审美迁移",
    categoryId: "music",
    category: "音乐",
    summary:
      "音乐节的草坪不只听歌，还是一年一度的审美现场。穿搭风格的更替，往往比歌单更早预告下一季的流行。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20an%20outdoor%20music%20festival%20field%20with%20abstract%20geometric%20shapes%20in%20fresh%20green%20coral%20and%20cream%20tones%2C%20stylized%20fashion%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20no%20text%2C%20clean%20modern%20composition&width=1200&height=800&seq=gty-cover-06&orientation=landscape",
    heat: 6120,
    comments: 219,
    views: 71800,
    author: "松弛感研究社",
    authorRole: "特约撰稿",
    publishedAt: "2026-09-04",
    readTime: 4,
    tags: ["音乐节", "穿搭", "审美"],
    content: [
      "前几年音乐节的关键词是野餐风：格纹毯、编织包、宽檐帽，好看是好看，但经不起泥地和降温的考验。今年明显不同，机能风的防水外套和厚底鞋成了草坪上的主流。",
      "这个变化背后其实很实际：音乐节从「拍照打卡」的场景，逐渐回归到「站一整天听歌」的场景。穿搭的第一诉求从出片变成了能待得住，审美跟着功能一起迁移。",
      "当然也有坚持仪式感的人。有用户在讨论区分享，自己依然会为了喜欢的乐队认真挑一条裙子，因为「舒服的衣服随时能穿，值得纪念的场合不是每天都有」。",
      "两种选择并不冲突。草坪足够大，能容下格纹毯，也能容下冲锋衣，真正被讨论的从来不是审美对错，而是你是否愿意为自己的选择负责。",
    ],
    timeline: [
      { time: "08-30", text: "多场音乐节同期举办，穿搭话题升温" },
      { time: "09-02", text: "「机能风取代野餐风」的判断引发讨论" },
      { time: "09-04", text: "话题进入音乐分类推荐位" },
    ],
    relatedIds: ["concert-yingyuan-neijuan", "film-guzhuang-zaoxing", "variety-jianji-zhengyi"],
  },
  {
    id: "variety-jianji-zhengyi",
    title: "综艺剪辑争议：镜头分配背后到底有没有玄机",
    categoryId: "variety",
    category: "综艺",
    summary:
      "同一段素材，换个剪辑顺序就是完全不同的故事。当观众的镜头感越来越强，剪辑本身也成了被审视的文本。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20an%20editing%20timeline%20made%20of%20abstract%20colored%20blocks%20in%20warm%20coral%20amber%20and%20cream%20tones%2C%20stylized%20post%20production%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20no%20text%2C%20clean%20composition&width=1200&height=800&seq=gty-cover-07&orientation=landscape",
    heat: 5560,
    comments: 197,
    views: 62300,
    author: "镜头前一秒",
    authorRole: "内容编辑",
    publishedAt: "2026-09-03",
    readTime: 5,
    tags: ["综艺", "剪辑", "幕后"],
    content: [
      "这一季争议的起点是一个三秒的转场。有观众逐帧比对后发现，某个反应镜头被放在了并不属于它的位置，情绪因此被放大了。截图一出，讨论迅速从「好看」转向「有没有被引导」。",
      "剪辑本来就是为了叙事服务的，把散乱的素材整理成一条清晰的情绪线，是专业能力的体现。真正的分歧在于，观众是否接受自己看到的故事是「被整理过的」。",
      "有从事后期的用户在讨论区做了科普：一档常规综艺的素材量可能是成片的几十倍，取舍不可避免。这条解释获得了不少认同，但也有人追问，取舍的标准是什么，谁来决定。",
      "一个比较温和的共识正在形成：观众不拒绝剪辑，只拒绝被当成不懂。把逻辑讲清楚，比反复强调「真实呈现」更有说服力。",
    ],
    timeline: [
      { time: "08-31", text: "转场截图流出，逐帧分析贴走红" },
      { time: "09-01", text: "后期从业者下场科普，讨论转向专业层面" },
      { time: "09-03", text: "话题进入综艺分类热榜" },
    ],
    relatedIds: ["variety-mingchangmian-2026", "industry-duanju-nengreng-jiu", "film-dajieju-lanwei"],
  },
  {
    id: "film-guzhuang-zaoxing",
    title: "古装剧造型同质化，观众的审美疲劳到哪一步了",
    categoryId: "film",
    category: "影视",
    summary:
      "相似的妆发、相似的配色、相似的滤镜，当不同朝代的角色看起来像同一个剧组，观众的耐心开始被消耗。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20flowing%20traditional%20Chinese%20silk%20fabric%20and%20abstract%20pattern%20shapes%20in%20warm%20coral%20amber%20and%20cream%20tones%2C%20stylized%20costume%20design%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20no%20text%2C%20elegant%20composition&width=1200&height=800&seq=gty-cover-08&orientation=landscape",
    heat: 5330,
    comments: 241,
    views: 58600,
    author: "考据一下",
    authorRole: "特约撰稿",
    publishedAt: "2026-09-02",
    readTime: 6,
    tags: ["古装剧", "造型", "审美"],
    content: [
      "把近两年几部古装剧的角色海报并排摆放，如果隐去剧名，很难第一时间判断它们属于哪个朝代，甚至分不清是不是同一部剧。这种「看起来都差不多」的感受，正在成为普遍反馈。",
      "同质化的原因并不神秘：一套被验证过的造型方案风险最低，平台、制片、演员团队都倾向于沿用。可是当所有人都选择最安全的方案，观众看到的就是一片平坦，没有记忆点。",
      "也有反例。今年有一部小成本古装剧因为大量使用手工染织面料和不对称发饰出圈，成本并不高，但在细节上足够克制。讨论区的评价很直接：不是没钱做，是没用心做。",
      "审美疲劳的关键从来不是「重复」本身，而是重复之后没有递进。观众可以接受熟悉的风格，但很难接受在不同作品里看到完全一样的答案。",
    ],
    timeline: [
      { time: "08-26", text: "对比海报合集在讨论区传播" },
      { time: "08-29", text: "「同质化」成为古装剧讨论高频词" },
      { time: "09-02", text: "小成本剧组的手工造型案例被大量转发" },
    ],
    relatedIds: ["film-dajieju-lanwei", "concert-yingyuan-neijuan", "variety-jianji-zhengyi"],
  },
  {
    id: "meme-biaoqingbao-chuandi",
    title: "网络热梗是怎么火起来的：一个表情包的完整传播路径",
    categoryId: "meme",
    category: "网络热梗",
    summary:
      "从一条评论里的口误，到全网模仿的口头禅，热梗的走红很少是偶然。它通常要经过四个阶段，而每个阶段都有不同的推手。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20colorful%20speech%20bubbles%20and%20smiley%20shapes%20spreading%20outward%20in%20warm%20coral%2C%20amber%20and%20cream%20tones%2C%20stylized%20internet%20culture%20poster%20aesthetic%2C%20soft%20grain%20texture%2C%20no%20text%2C%20clean%20modern%20composition&width=1200&height=800&seq=gty-cover-09&orientation=landscape",
    heat: 6015,
    comments: 203,
    views: 69400,
    author: "梗学研究员",
    authorRole: "特约撰稿",
    publishedAt: "2026-09-01",
    readTime: 4,
    tags: ["网络热梗", "传播", "内容生态"],
    content: [
      "几乎所有热梗的起点都很小：一句说岔了的台词、一个不太标准的口音、一次略显抓马的表情。这些小失误之所以能被放大，往往是因为它们同时满足了两个条件——足够好复制，又足够有情绪。",
      "第一阶段是圈层内的使用。梗最早在固定的社区里流通，使用者彼此熟悉语境，不需要解释就能会心一笑。这个阶段的传播速度慢，但黏性最高，也决定了这个梗会不会被说烂。",
      "第二阶段是二创扩散。当创作者开始用同一个梗套进不同的情境，梗就从一句话变成了一种句式。能套进越多场景的梗，生命周期就越长，因为它不再依赖原本的语境。",
      "第三阶段是主流化与反噬。当梗进入大众视野，就必然出现「过气」的抱怨。很多人误以为这是热度下降，其实只是一个梗从圈层符号变成了公共词汇，它没有消失，只是不再是身份的标识。",
      "第四阶段是沉淀。绝大多数梗会在几周内退场，只有少数会进入日常表达。判断标准很简单：当人们用它的时候，已经不再意识到自己在用一个梗，它就真正留下来了。",
    ],
    timeline: [
      { time: "08-18", text: "原始素材在评论区被提炼成一句可复制的表达" },
      { time: "08-23", text: "二创账号开始批量套用句式，相关话题量快速上升" },
      { time: "08-28", text: "梗进入大众视野，关于「说烂了」的讨论同步出现" },
      { time: "09-01", text: "讨论区围绕「梗的生命周期」展开总结性讨论" },
    ],
    relatedIds: ["variety-mingchangmian-2026", "star-gongzuoshi-huiying", "industry-duanju-nengreng-jiu"],
  },
];